import styled from 'styled-components';
import { useEffect, useState } from 'react';
import ReactDatePicker from 'react-datepicker';

const DataRangeWrapper = styled.div`
  position: relative;
`;

const DataRangePopup = styled.div`
  position: absolute;
  right: 0;
  z-index: 1;
`;

const DateInput = styled.div`
  width: max-content;
  height: 50px;

  align-items: center;
  background-color: hsl(0, 0%, 100%);
  border-color: hsl(0, 0%, 80%);
  border-radius: 35px;
  border-style: solid;
  border-width: 1px;
  box-shadow: 0px 0px 3px #c4c4c4;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  position: relative;
  transition: all 100ms;
  box-sizing: border-box;
  border: 0;
  text-align: center;
  padding: 0 10px;
  color: hsl(0, 0%, 50%);
  cursor: default;

  &:hover {
    box-shadow: 0px 0px 15px #c4c4c4;
  }

  &.disabled {
    pointer-events: none;
    background-color: hsl(0, 0%, 95%);
  }
`;

const ClearDate = styled.div`
  border-left: solid 1px hsl(0, 0%, 80%);
  color: hsl(0, 0%, 50%);
  font-size: 20px;
  font-weight: 300;
  padding: 10px;
  margin-left: 5px;
  cursor: pointer;
`;

interface DaterangePickerProps {
  selected?: Date | null;
  onChange?(date: [Date | null, Date | null], event?: React.SyntheticEvent<any, Event>): void;
  startDate?: Date | null;
  endDate?: Date | null;
  selectsRange?: boolean;
  inline?: boolean;
  isClearable?: boolean;
  label?: string;
  disabled?: boolean;
}

export default function DaterangePicker({
  //selected,
  onChange,
  //startDate,
  //endDate,
  selectsRange,
  inline,
  isClearable,
  label,
  disabled,
}: DaterangePickerProps) {
  const [dates, setDates] = useState<[Date | null, Date | null]>([null, null]);
  const [collapsed, isCollapsed] = useState<boolean>(false);

  useEffect(() => {
    if (!onChange) return;

    if (isClearable && !dates[0] && !dates[1]) {
      onChange(dates);
      isCollapsed(false);
      return;
    }

    if (!selectsRange && dates[0]) {
      onChange(dates);
      isCollapsed(false);
      return;
    }

    if (selectsRange && dates[0] && dates[1]) {
      onChange(dates);
      isCollapsed(false);
      return;
    }
  }, [dates]);

  return (
    <DataRangeWrapper>
      <DateInput
        className={`${disabled ? 'disabled' : ''} `}
        onClick={() => {
          if (disabled) return;
          isCollapsed(!collapsed);
        }}
      >
        {dates[0] && !dates[1]
          ? dates[0].toDateString()
          : dates[0] && dates[1]
          ? `${dates[0].toDateString()} - ${dates[1].toDateString()}`
          : label}

        {(dates[0] || dates[1]) && (
          <ClearDate
            onClick={(evt) => {
              evt.stopPropagation();
              setDates([null, null]);
            }}
          >
            x
          </ClearDate>
        )}
      </DateInput>
      {collapsed && (
        <DataRangePopup>
          <ReactDatePicker
            selected={dates[0]}
            onChange={(date: [Date | null, Date | null]) => setDates(date)}
            startDate={dates[0] ?? undefined}
            endDate={dates[1]}
            selectsRange={selectsRange as any}
            inline={inline}
            isClearable={isClearable}
          />
        </DataRangePopup>
      )}
    </DataRangeWrapper>
  );
}
